import { useEffect, useMemo, useState } from "react";
import Header from "./Sections/Header";
import Slider from "./Sections/Slider";
import About from "./Sections/About";
import Services from "./Sections/Services";
import Staff from "./Sections/Staff";
import Footer from "./Sections/Footer";
import "./Style/theme1.scss";
import { useTranslation } from "react-i18next";

const ClientSiteTheme1 = (props) => {
  const { t, i18n } = useTranslation("clientSite");
  const { t: a } = useTranslation("auth");
  const [lang, setLang] = useState(props.lang || i18n.language || "en");

  const supported = useMemo(
    () => (i18n.options?.supportedLngs || ["en", "es"]).filter((l) => l !== "cimode"),
    [i18n.options?.supportedLngs]
  );

  useEffect(() => {
    document.title = props.site.siteTitle;
    if (props.lang) {
      i18n.changeLanguage(props.lang);
      setLang(props.lang);
    }
  }, [props.site.siteTitle, props.lang, i18n]);

  return (
    <div
      className="client-site-shell"
      data-theme={props.site.themeId === 2 ? "two" : "one"}
    >
      <Header site={props.site} />
      <main>
        <Slider site={props.site} />

        {props.site.aboutUsPageEnabled ? (
          <section id="about" className="site-section site-section--about">
            <div className="site-container">
              <About site={props.site} />
            </div>
          </section>
        ) : null}

        {props.site.servicePageEnabled ? (
          <section id="services" className="site-section site-section--services">
            <div className="site-container">
              <Services site={props.site} />
            </div>
          </section>
        ) : null}

        {props.site.staffPageEnabled ? (
          <section id="staff" className="site-section site-section--staff">
            <div className="site-container">
              <Staff site={props.site} />
            </div>
          </section>
        ) : null}
      </main>

      <Footer site={props.site}>
        <div className="site-langWrap">
          <label htmlFor="lang-switch" className="visually-hidden">
            {t("login.lang.ariaLabel")}
          </label>
          <select
            id="lang-switch"
            value={lang}
            onChange={(e) => {
              i18n.changeLanguage(e.target.value);
              setLang(e.target.value);
            }}
            aria-label={t("login.lang.ariaLabel")}
            className="site-langSelect"
          >
            {supported.map((code) => (
              <option key={code} value={code}>
                {a(`login.lang.names.${code}`, code.toUpperCase())}
              </option>
            ))}
          </select>
        </div>
      </Footer>
    </div>
  );
};

export default ClientSiteTheme1;
